'use client';

import { atom } from 'jotai';

export const openFinanceLeadModalAtom = atom(false);
